import { withRouter } from "../../utils/withRouter";
import { useCallback, useEffect, useState, useRef, useMemo } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import MaterialTable from "material-table";
import { tableIcons } from "../../tableIcons";
import { useDispatch, useSelector } from "react-redux";
import { getProductDetails, getDashboardData } from "../../service/service";
import { CircularProgress, TablePagination } from "@material-ui/core";
import { Checkbox } from "@material-ui/core";
import config from "../../config";
import { currencyFormatter } from "../../helper";
import moment from "moment";
import {
  CloseCircleOutlined,
  DownOutlined,
  EllipsisOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import Table from "../table";
import {
  Dropdown,
  Menu,
  Button,
  theme,
  DatePicker,
  Row,
  Col,
  Card,
  Select,
  Input,
  InputNumber,
  Tooltip,
  Typography,
  Popover,
  Tag,
  Modal as AntdModal,
  Divider,
  App,
  message,
} from "antd";
import KitchenThermalTemplate from "../Kitchen/kitchen-thermal-bill";
import ThermalTemplate from "../billing/thermalTemplate";
import { sumBy } from "lodash";
// import { useMultipleKeyPress } from "../../hooks/useMultipleKeyPress";
import ReactToPrint from "react-to-print";
import { MdOutlineClose } from "react-icons/md";
import { VscAccount } from "react-icons/vsc";
import InvoiceTemplate from "../billing/InvoiceTemplate";
import AnalyticsCard from "../analyticsCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BiMinus, BiMinusCircle, BiPlus, BiPlusCircle } from "react-icons/bi";
import {
  faDollarSign,
  faIndianRupeeSign,
  faLessThanEqual,
  faPesoSign,
} from "@fortawesome/free-solid-svg-icons";
import CountUp from "react-countup";
import Loader from "../loader";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import { AiFillEdit, AiOutlineInfoCircle } from "react-icons/ai";
import {
  IoIosCheckmarkCircleOutline,
  IoIosCloseCircleOutline,
} from "react-icons/io";
import { useAccess } from "../../provider/AccessProvider";
import { DASHBOARDACCESS } from "../../utils/constant";

const { useToken } = theme;
const { RangePicker } = DatePicker;

const OverView = (props) => {
  const shopData = useSelector((state) => state.shopDetails);
  const {
    token: { colorPrimary },
  } = useToken();

  const currentRequestRef = useRef(null);

  const invoiceSettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );
  const { modal: toastModal } = App.useApp();
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const billLineSettings = useSelector((state) => state.settings.settings);
  const [bills, setBills] = useState([]);
  const shopDetails = useSelector((state) => state.shopDetails);
  const [totalSales, setTotalSales] = useState(0.0);
  const [customerCount, setCustomerCount] = useState(0);
  const [totalBills, setTotalBills] = useState(0);
  const [todayBills, setTodayBills] = useState("");
  const [inventoryCount, setInventoryCount] = useState(0);
  const [todaySale, setTodaySale] = useState(0);
  const [billArray, setBillArray] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [loyaltyCouponRedeem, setLoyaltyCouponRedeem] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [cancelBillModal, setCancelBillModal] = useState(false);
  const [salesReturnModal, setSalesReturnModal] = useState(false);
  const [billId, setBillId] = useState("");
  const [salesReturn, setSalesReturn] = useState(0);
  const [reasonForCancellation, setReasonForCancellation] = useState("");
  const [cancelType, setCancelType] = useState("");
  const [returnProducts, setReturnProducts] = useState([]);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [taxList, setTaxList] = useState([]);
  const [dateValue, setDateValue] = useState("today");
  const [customDate, setCustomDate] = useState([]);
  const [sumOfSelectedReturn, setSumOfSelectedReturn] = useState(0);
  const [returnBillInVoice, setReturnBillInVoice] = useState("");
  const [openRangePicker, setOpenRangePicker] = useState(false);
  const [billFullyReturned, setBillFullyReturned] = useState(false);
  const printRef = useRef();
  // const [selectedReturnId, setSelectedReturnId] = useState([]);
  const [returnItemModal, setReturnItemModal] = useState(false);
  const [returnProductsList, setReturnProductsList] = useState({ items: [] });
  const [returnPaymentMethod, setReturnPaymentMethod] = useState("");
  const [selectAllItems, setSelectAllItems] = useState(false);
  const [amountToBeRepaid, setAmountToBeRepaid] = useState("");
  const [creditAmount, setCreditAmount] = useState("");
  const [creditAdjust, setCreditAdjust] = useState("");
  const [isFetchLoading, setIsFetchLoading] = useState(false);
  const [overallDiscount, setOverallDiscount] = useState({
    show: true,
    amount: 0,
    returned: false,
  });
  const [selectAll, setSelectAll] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [otherCharger, setOtherCharger] = useState([]);
  const [returnProductsItem, setReturnProductsItem] = useState([]);
  const access = useAccess(DASHBOARDACCESS);
  console.log("access33434", access);
  // const [adjustingFromDiscount, setAdjustingFromDiscount] = useState("");
  /* Importing the useDispatch hook from the react-redux library. */
  const dispatch = useDispatch();
  const [{ thermalPayload, isShow }, setThermalPayload] = useState({
    thermalPayload: {},
    isShow: false,
  });
  // useMultipleKeyPress(props);

  useEffect(() => {
    if (returnProductsItem.length > 0) {
      var priceArray = [];
      // const choosesProduct = returnProductsItem.filter((data) => {
      //   return data.tableData.checked;
      // });
      // if (choosesProduct.length > 0) {
      returnProductsItem.forEach((data) => {
        const returnedCounts =
          parseFloat(data.returned || 0) -
          parseFloat(data.tempReturnedCount || 0);

        if (returnedCounts === 1 && parseFloat(data.count) === 0) {
          priceArray.push(parseFloat(data.itemTotal));
        } else {
          const perQuantity =
            parseFloat(data.itemTotal) / parseFloat(data.count || 0);
          priceArray.push(
            perQuantity *
              (parseFloat(data.returned) -
                parseFloat(data.tempReturnedCount || 0))
          );
        }
      });
      if (priceArray.length > 0) {
        var sumOfReturn = priceArray.reduce(
          (a, b) => parseFloat(a) + parseFloat(b),
          0
        );
        setAmountToBeRepaid(sumOfReturn);
        setSumOfSelectedReturn(sumOfReturn);
      }
    } else {
      setSumOfSelectedReturn(0);
      setAmountToBeRepaid(0);
    }
  }, [returnProductsItem]);

  useEffect(() => {
    if (returnProductsList && returnItemModal) {
      let discountValue = 0;
      const discountType = returnProductsList.discountType
        ? returnProductsList.discountType
        : returnProductsList.otherDetails.discountType;
      const discount = returnProductsList.discount
        ? returnProductsList.discount
        : returnProductsList.otherDetails.discount;
      if (discountType && discount) {
        if (discountType === "flat") {
          if (discount) {
            discountValue = discount;
          }
        } else {
          if (discountType === "percentage") {
            if (discount) {
              discountValue =
                (parseFloat(returnProductsList.otherDetails.productTotal) *
                  parseFloat(discount)) /
                100;
            }
          }
        }
      }
      setOverallDiscount((prev) => ({
        ...prev,
        amount: discountValue,
      }));
      let otherCharges = returnProductsList.otherDetails.otherCharges;
      let orderChargeAmount = 0;
      const returnedOtherChargers = [];
      if (returnProductsList.billReturn) {
        returnProductsList.billReturn.forEach((i) => {
          if (i.otherCharges) {
            returnedOtherChargers.push(...i.otherCharges);
          }
        });

        otherCharges = otherCharges.map((data) => {
          const find = returnedOtherChargers.find((i) => {
            return i.id === data.id;
          });

          if (find) {
            return find;
          }
          return {
            ...data,
            ...find,
          };
        });
      }
      if (otherCharges.length) {
        otherCharges.forEach((data) => {
          if (parseFloat(data.price) && !data.returned) {
            orderChargeAmount += parseFloat(data.price);
          }
        });
        setAmountToBeRepaid(sumOfSelectedReturn + orderChargeAmount);
      }
      const tempReturnProductsLength = returnProductsItem.length;
      const returnProductsLength = returnProductsList.items.filter(
        (i) => i.fullyReturned
      ).length;
      if (
        tempReturnProductsLength + returnProductsLength ===
        returnProductsList.items.length
      ) {
        const isReturnedAll = returnProductsItem.every(
          (i) => parseFloat(i.count) === parseFloat(i.returned)
        );
        if (isReturnedAll && sumOfSelectedReturn > 0) {
          const isRemovedDiscount =
            returnProductsList.billReturn.returnItem?.some(
              (i) => i.discount === "removed"
            );
          if (!isRemovedDiscount) {
            setAmountToBeRepaid((prev) => prev - discountValue);
          }
          setSelectAll(true);
        } else {
          setSelectAll(false);
        }
      }

      if (returnProductsList.roundOff && sumOfSelectedReturn > 0) {
        setAmountToBeRepaid((prev) => {
          return prev + parseFloat(returnProductsList.roundOff);
        });
      }
    }
  }, [
    returnProductsList,
    returnItemModal,
    sumOfSelectedReturn,
    overallDiscount.returned,
    overallDiscount.amount,
    returnProductsItem,
  ]);

  useEffect(() => {
    if (sumOfSelectedReturn != 0) {
      if (parseFloat(returnProductsList.balanceAmount) > 0) {
        if (
          parseFloat(sumOfSelectedReturn) <=
          parseFloat(returnProductsList.balanceAmount)
        ) {
          setAmountToBeRepaid(0);
          setCreditAdjust(parseFloat(sumOfSelectedReturn));
        } else if (
          sumOfSelectedReturn >= parseFloat(returnProductsList.balanceAmount)
        ) {
          let repayAfterClearingCredits =
            parseFloat(sumOfSelectedReturn) -
            parseFloat(returnProductsList.balanceAmount);
          setCreditAdjust(returnProductsList.balanceAmount);
          setAmountToBeRepaid(
            (prev) => prev - parseFloat(returnProductsList.balanceAmount)
          );
        }
      } else {
        setCreditAmount(0);
        setCreditAdjust(0);
      }
    } else {
      setCreditAmount(0);
      setAmountToBeRepaid(0);
      setCreditAdjust(0);
    }
  }, [sumOfSelectedReturn]);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "600px",
      minHeight: "500px",
      backGround: "#ffff",
    },
  };
  const setToDefault = () => {
    setReturnItemModal(false);
    setReturnPaymentMethod("");
    setCancelType("");
    setReasonForCancellation("");
    setCancelLoading(false);
    setReturnProductsItem([]);
  };
  const handleDateRange = (v) => {
    setBills([]);
    if (v === null) {
      setDateValue("today");
      setCustomDate([]);
    }
    setCustomDate(v);
  };
  const paymentMethodGenerator = (data) => {
    if (Array.isArray(data)) {
      var temp = data.map((methods) => {
        return methods.method;
      });
      return temp.toString();
    } else {
      return data;
    }
  };
  const clearCreditFlow = async () => {
    try {
      var res = await fetch(`${config.newApiGateway}/tools/clearCredits`, {
        method: "POST",
        body: JSON.stringify({
          billId: returnProductsList.billId,
          balanceAmount: returnProductsList.balanceAmount,
          amountPaid: parseFloat(creditAdjust),
          paymentMethod: [
            {
              method: "returnedProducts",
              amountPaid: parseFloat(creditAdjust),
            },
          ],
          updatedDate: new Date().toISOString().substring(0, 10),
          updatedTime: new Date().toLocaleString("en-IN", {
            hour12: true,
            hour: "2-digit",
            minute: "2-digit",
          }),
          updatedBy: shopData.phoneNumber,
          updatedByName: shopData.empId ? shopData.employeeName : "Shop Owner",
        }),
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return alert(res.message);
      }
    } catch (err) {
      console.error("Err", err);
      alert("Error while update balance. Please try again.");
    }
  };

  useEffect(() => {
    if (shopDetails.shopType !== "Restaurent") {
      if (shopDetails.shopId) {
        fetch(`${config.newApiGateway}/bill/customBillsettings`, {
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ shopId: shopDetails.shopId, type: "update" }),
          method: "POST",
        })
          .then((res) => res.json())
          .then((data) => {
            let Checkboxdata = data.newBillsettings;
            let UpdateCheckbox = {};
            for (let i = 0; i < Checkboxdata.length; i++) {
              Object.assign(UpdateCheckbox, Checkboxdata[i]);
            }

            dispatch({
              type: "INVOICE-NEWBILLSETTINGS",
              payload: UpdateCheckbox,
            });

            return Checkboxdata;
          });
      }
    }
  }, [shopDetails.shopId]);

  const dateType = (date) => {
    if (date === "today") {
      return {
        from: moment().format("YYYY-MM-DD"),
        to: moment().format("YYYY-MM-DD"),
      };
    } else if (date === "week") {
      return {
        from: moment().subtract(1, "week").format("YYYY-MM-DD"),
        to: moment().format("YYYY-MM-DD"),
      };
    } else if (date === "month") {
      return {
        from: moment().subtract(30, "days").format("YYYY-MM-DD"),
        to: moment().format("YYYY-MM-DD"),
      };
    }
  };

  const handleDateChange = (v) => {
    if (v === "custom") {
      setBills([]);
    }
    setDateValue(v);
  };
  const checkReturnedItems = (data) => {
    // console.log("data2323", data);
    if (data.billReturn.length > 0) {
      const isFullyReturned = data.items.every((i) => i.fullyReturned === true);
      return isFullyReturned ? (
        <Tag
          color="purple"
          style={{
            width: 120,
            textAlign: "center",
          }}
        >
          Fully Returned
        </Tag>
      ) : (
        <Tag
          color="magenta"
          style={{
            width: 120,
            textAlign: "center",
          }}
        >
          Partially Returned
        </Tag>
      );
      // }
    }
  };

  const handlePrint = async (data, type) => {
    const isAccess = access.reprint();
    if (!isAccess) {
      return;
    }
    const selectedBill = bills.find((bill) => bill.billId === data.billId);
    if (invoiceSettings.printerType !== "") {
      let thermalData = {
        isReprint: true,
        billReturn: data.billReturn,
        orderType: data.orderType,
        settings: {
          ...billLineSettings,
          otherChargesField: selectedBill?.otherDetails?.otherCharges
            ? selectedBill?.otherDetails?.otherCharges
            : {},
        },
        products: data.items,
        result: {
          roundOffAmount: selectedBill.roundOff,
          couponDiscountAmount: selectedBill?.otherDetails?.couponDiscountAmount
            ? selectedBill?.otherDetails?.couponDiscountAmount
            : selectedBill.couponDiscount,
          billSubTotal: selectedBill.otherDetails?.productTotal
            ? selectedBill.otherDetails?.productTotal
            : selectedBill?.productTotal,
          billFinalTotal: selectedBill.amountPaid,
          invoiceNumber: selectedBill.invoiceNumber,
          invoicePrefixField: selectedBill.invoicePrefix,
        },
        shopDetails: shopData,
        discountType: {
          billDiscountType: !selectedBill.discountType
            ? selectedBill.otherDetails?.discountType
              ? selectedBill.otherDetails?.discountType
              : ""
            : selectedBill.discountType,
        },
        loyaltyDiscount: selectedBill.loyaltyDiscount,
        couponObj: selectedBill.coupon ? selectedBill.coupon : {},
        loyaltyObj: selectedBill.loyalty ? selectedBill.loyalty : {},
        taxList: taxList,
        billInput: {
          billDiscount: !selectedBill.discount
            ? selectedBill.otherDetails?.discount
              ? selectedBill.otherDetails?.discount
              : ""
            : selectedBill.discount,
          billPaid: selectedBill.balanceAmount
            ? selectedBill.balanceAmount < 0
              ? parseFloat(selectedBill.amountPaid) +
                Math.abs(parseFloat(selectedBill.balanceAmount))
              : parseFloat(selectedBill.amountPaid) -
                Math.abs(parseFloat(selectedBill.balanceAmount))
            : selectedBill.amountPaid,
          billAmountDue: selectedBill.balanceAmount
            ? selectedBill.balanceAmount
            : 0,
          notes: selectedBill.otherDetails?.notes
            ? selectedBill.otherDetails.notes
            : selectedBill.notes,
        },
        customerDetails: {
          customerPhoneNumber: selectedBill.customerPhoneNumber.replace(
            shopDetails.country.dialCode,
            ""
          ),
          customerName: selectedBill.customerName,
        },
        deliveryAddress: selectedBill.otherDetails?.shippingAddress
          ? selectedBill.otherDetails.shippingAddress
          : "",
        billingAddress: selectedBill.otherDetails?.billingAddress,
        paymentMethod: selectedBill.otherDetails?.paymentMethod
          ? paymentMethodGenerator(selectedBill.otherDetails.paymentMethod)
          : paymentMethodGenerator(selectedBill.paymentMethod),
        loyaltyPoints: selectedBill.otherDetails?.currentLoyaltyPoints
          ? selectedBill.otherDetails.currentLoyaltyPoints
          : 0,
        chargeForDelivery: selectedBill?.chargeForDelivery,
        discount: selectedBill?.discount,
      };
      console.log("thermalData222", thermalData);
      setThermalPayload((prev) => ({
        ...prev,
        thermalPayload: thermalData,
        isShow: true,
      }));
    }
  };
  useEffect(() => {
    console.log("returnProductsList11", returnProductsList);
    // if (returnProductsList.orderDetails) {
    //   if (returnProductsList.orderDetails.otherCharges.length) {
    //     setOtherCharger(returnProductsList.orderDetails.otherCharges);
    //   }
    // }

    // if (returnProductsList.items) {
    //   var alreadyReturned = returnProductsList.items.filter((data) => {
    //     if (data.returned) {
    //       return data.productId;
    //     }
    //   });
    //   alreadyReturned.length >= returnProductsList.items.length
    //     ? setBillFullyReturned(true)
    //     : setBillFullyReturned(false);
    // }
  }, [returnProductsList]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef.current]);

  const handleViewBill = async (billId) => {
    try {
      const res = await fetch(
        `https://ghoshak-image.s3.ap-south-1.amazonaws.com/${billId}.pdf`
      );
      if (res.status === 200) {
        window.open(
          `https://ghoshak-image.s3.ap-south-1.amazonaws.com/${billId}.pdf`
        );
      } else {
        let res = await fetch(`${config.newApiGateway}/bill/getInvoice`, {
          method: "POST",
          headers: {
            "x-api-key": `${config.newApiKey}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "update",
            billId: billId,
          }),
        });
        res = await res.json();
        if (res.code === "ERROR") {
          return;
        }
        window.open(
          `https://ghoshak-image.s3.ap-south-1.amazonaws.com/${billId}.pdf`
        );
      }
    } catch (error) {}
  };

  const menu = (data) => {
    let noProductReturned = true;
    let filteredArr = [];
    if (data.items && data.items.length > 0) {
      filteredArr = data.items.filter((data) =>
        data.isReturned ? data.isReturned : false
      );
    }
    if (data.items && data.items.length > 0) {
      if (filteredArr.length === data.items.length) {
        noProductReturned = false;
      }
    }

    console.log("data1988", data);

    return (
      <Menu>
        <ReactToPrint
          trigger={() => {
            return (
              <Menu.Item
                style={{
                  width: "150px",
                }}
              >
                Print
              </Menu.Item>
            );
          }}
          onBeforeGetContent={() => handlePrint(data, "print")}
          content={reactToPrintContent}
        />
        <Menu.Item
          style={{
            width: "150px",
          }}
          onClick={() => handleViewBill(data.billId)}
          key="view"
        >
          View
        </Menu.Item>

        <>
          {!data.billCancelled && noProductReturned && (
            // <Menu.Item
            //   key="cancelBill"
            //   size="sm"
            //   style={{ width: "150px" }}
            //   variant="outline-danger"
            //   onClick={() => {
            //     setCancelBillModal(true);
            //     setCancelType("cancelBill");
            //     setBillId(data.billId);
            //   }}
            // >
            //   Cancel Bill
            // </Menu.Item>
            <Menu.Item
              key="cancelBill"
              size="sm"
              style={{ width: "150px" }}
              variant="outline-danger"
              onClick={() => {
                const isAccess = access.returnItem();
                if (!isAccess) {
                  return;
                }
                const returnBillData = data.items.map((i, index) => {
                  const perQuantity =
                    parseFloat(i.itemTotal) / parseFloat(i.count || 0);
                  return {
                    ...i,
                    tempReturnedCount: i.returned || 0,
                    tempCount:
                      parseFloat(i.count) - parseFloat(i.returned || 0),
                    perQuantity: perQuantity,
                    tableData: {
                      id: index,
                      checked: false,
                    },
                  };
                });

                const billReturn = data.billReturn;
                let otherCharges = data.otherDetails?.otherCharges;
                let returnOtherCharges = [];

                if (billReturn.length > 0) {
                  billReturn.forEach((item) => {
                    console.log("item12666", item);
                    if (item.otherCharges) {
                      returnOtherCharges.push(...item.otherCharges);
                    }
                    if (item.discount === "removed") {
                      setOverallDiscount((prev) => ({
                        ...prev,
                        show: false,
                        returned: true,
                      }));
                    }
                  });
                }
                let result = [];
                if (otherCharges.length > 0) {
                  result = otherCharges.map((item) => {
                    const find = returnOtherCharges.find(
                      (i) => i.id === item.id
                    );
                    console.log("find12", find);
                    if (find) {
                      return {
                        ...item,
                        returned: true,
                      };
                    }
                    if (item.price) {
                      return { ...item, tempReturned: true };
                    }
                    return item;
                  });
                }

                setOtherCharger(result);

                setReturnProductsList({
                  ...data,
                  items: returnBillData,
                  otherDetails: {
                    ...data.otherDetails,
                    otherCharges: otherCharges,
                  },
                });
                //setReturnProductsList(data);
                setReturnItemModal(true);
                setBillId(data.billId);
              }}
            >
              Return Items
            </Menu.Item>
          )}
        </>
      </Menu>
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      let product = await getProductDetails(shopData.shopId, shopData.empId);
      if (product.products) {
        const addToLocalStroage = product?.products?.map((i) => {
          let label = i.productName;
          if (
            i.unitOfMeasurment !== "Others" &&
            i.unitOfMeasurment !== "" &&
            !i.unitOfMeasurment !== true
          ) {
            label = `${i.productName} (${i.unitOfMeasurment})`;
          }
          return {
            id: i.productId,
            name: label,
            eanCode: i.productEANCode,
            productCode: i.productCode,
            color: i.color,
            size: i.size,
            value: i.productName.toLowerCase(),
          };
        });
        dispatch({
          type: "SET_PRODUCTS_SEARCH",
          payload: addToLocalStroage,
        });
        dispatch({
          type: "SET_PRODUCT_LIST",
          payload: product.products,
        });
      }
      if (Array.isArray(product)) {
        const addToLocalStroage = product?.map((i) => {
          let label = i.productName;
          if (
            i.unitOfMeasurment !== "Others" &&
            i.unitOfMeasurment !== "" &&
            !i.unitOfMeasurment !== true
          ) {
            label = `${i.productName} (${i.unitOfMeasurment})`;
          }
          return {
            id: i.productId,
            name: label,
            eanCode: i.productEANCode,
            productCode: i.productCode,
            color: i.color,
            size: i.size,
            value: i.productName.toLowerCase(),
          };
        });
        dispatch({
          type: "SET_PRODUCTS_SEARCH",
          payload: addToLocalStroage,
        });
        dispatch({
          type: "SET_PRODUCT_LIST",
          payload: product,
        });
      }
      if (product !== undefined) setInventoryCount(product.length);
    };
    if (shopData.shopId) {
      fetchData();
    }
  }, [shopData.shopId]);

  const fetchDashboardData = async (payload) => {
    try {
      if (currentRequestRef.current) {
        currentRequestRef.current.abort();
      }
      const abortController = new AbortController();
      currentRequestRef.current = abortController;

      let res = await fetch(`${config.newApiGateway}/bill/getBillDetails`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shopId: shopDetails.shopId,
          from: moment(payload.fromDate).format("YYYY-MM-DD"),
          to: moment(payload.toDate).format("YYYY-MM-DD"),
          employeeId: payload.empId ? payload.empId : "",
          type: "bill",
          lastItem: payload.lastItem,
          // ...payload,
          empId: undefined,
          action: "getDashboardData",
        }),
        signal: abortController.signal,
      });
      if (abortController.signal.aborted) {
        return null;
      }

      res = await res.json();
      if (res?.data?.length > 0) {
        if (payload.lastItem) {
          setBills((prev) => {
            return [...prev, ...res.data];
          });
        } else {
          setBills(res.data);
        }
      }

      return res;
    } catch (err) {
      if (err.name === "AbortError") {
        console.log("Request was aborted");
        return null;
      }
      console.error("err", err);
      return null;
    }
  };

  const fetchDashboardBills = async (shopId, fromDate, toDate, empId) => {
    try {
      if (currentRequestRef.current) {
        currentRequestRef.current.abort();
      }
      setBills([]);
      setIsLoaded(false);
      setIsFetchLoading(false);
      await new Promise((resolve) => setTimeout(resolve, 100));

      let res = await fetchDashboardData({ shopId, fromDate, toDate, empId });
      if (!res) {
        return;
      }
      setIsLoaded(true);
      while (res?.lastItem) {
        setIsFetchLoading(true);
        console.log("lastItem", res.lastItem);
        const nextRespones = await fetchDashboardData({
          lastItem: res.lastItem,
          shopId,
          fromDate,
          toDate,
          empId,
        });
        if (!nextRespones) {
          break;
        }

        res = nextRespones;
      }
      setIsFetchLoading(false);
    } catch (err) {
      console.error(err);
      setIsLoaded(true);
      setIsFetchLoading(false);
    }
  };

  const getTotalValue = (bills = []) => {
    let totalBills = 0;
    let totalSales = 0;
    let customerCount = 0;
    let salesReturn = 0;
    let repaid = 0;
    let todayBills = 0;
    let todaySales = 0;
    let discountFlat = 0;
    let discountPer = 0;
    let temprepaidflat = 0;
    let temprepaiddis = 0;
    let temprepaidnormal = 0;
    let fullyReturnedTotal = 0;
    let cancelledBills = 0;
    bills.forEach((data, index) => {
      if (data.billCancelled) {
        cancelledBills += parseFloat(data.amountPaid);
        salesReturn = parseFloat(salesReturn) + parseFloat(data.amountPaid);
      } else {
        totalSales = parseFloat(totalSales) + parseFloat(data.amountPaid);

        if (data.billingDate === new Date().toISOString().substring(0, 10)) {
          todayBills += 1;
          todaySales = parseFloat(data.amountPaid) + parseFloat(totalSales);
        }
      }

      if (data.billReturn) {
        const isPartialBill = data.billReturn.some((i) => i.partial === true);
        console.log("isPartialBill", isPartialBill);
        if (!isPartialBill) {
          if (data.otherDetails) {
            if (
              data.otherDetails.discountType &&
              data.otherDetails.discount !== 0
            ) {
              if (
                data.otherDetails.discountType === "flat" &&
                data.otherDetails.discount !== 0
              ) {
                if (data.otherDetails.discount) {
                  data.items.forEach((value) => {
                    if (value.returned) {
                      temprepaidflat += parseFloat(value.itemTotal);
                    }
                  });
                  discountFlat += parseFloat(data.otherDetails.discount);
                }
              } else if (
                data.otherDetails.discountType === "percentage" &&
                data.otherDetails.discount !== 0
              ) {
                if (data.otherDetails.discount) {
                  let temprepaiddis1 = 0;
                  data.items.forEach((value) => {
                    if (value.returned) {
                      temprepaiddis1 += parseFloat(value.itemTotal);
                      temprepaiddis += parseFloat(value.itemTotal);
                    }
                  });
                  discountPer +=
                    (parseFloat(temprepaiddis1) *
                      parseFloat(data.otherDetails.discount)) /
                    100;
                }
              }
            } else {
              data.items.forEach((value) => {
                if (value.returned) {
                  temprepaidnormal += parseFloat(value.itemTotal);
                }
              });
            }

            var totalflatreturn = temprepaidflat - discountFlat;
            var totaldicreturn = temprepaiddis - discountPer;

            // repaid = temprepaidnormal + totalflatreturn + totaldicreturn;
          } else {
            // for mobile billl calculation
            if (data.discountType && data.discount !== 0) {
              if (data.discountType === "flat" && data.discount !== 0) {
                if (data.discount) {
                  data.items.forEach((value) => {
                    if (value.returned) {
                      temprepaidflat += parseFloat(value.itemTotal);
                    }
                  });
                  discountFlat += parseFloat(data.discount);
                }
              } else if (
                data.discountType === "percentage" &&
                data.discount !== 0
              ) {
                if (data.discount) {
                  let temprepaiddis1 = 0;
                  data.items.forEach((value) => {
                    if (value.returned) {
                      temprepaiddis1 += parseFloat(value.itemTotal);
                      temprepaiddis += parseFloat(value.itemTotal);
                    }
                  });
                  discountPer +=
                    (parseFloat(temprepaiddis1) * parseFloat(data.discount)) /
                    100;
                }
              }
            } else {
              data.items.forEach((value) => {
                if (value.returned) {
                  temprepaidnormal += parseFloat(value.itemTotal);
                }
              });
            }

            var totalflatreturn = temprepaidflat - discountFlat;
            var totaldicreturn = temprepaiddis - discountPer;

            // repaid = temprepaidnormal + totalflatreturn + totaldicreturn;
          }
          repaid = temprepaidnormal + totalflatreturn + totaldicreturn;
        } else if (isPartialBill) {
          const fullyReturned = data.items.every((i) => i.fullyReturned);
          if (!fullyReturned) {
            data.billReturn.forEach((value, index) => {
              repaid = parseFloat(repaid) + parseFloat(value.repayAmount);
              console.log("clearCredit88", value.repayMethod, "clearCredit");
              if (value.repayMethod === "clearCredits") {
                const creditHistory = data.creditHistory?.find((i) => {
                  return (
                    i.updatedTime ===
                    moment(value.returnedData, "YYYY-MM-DD hh:mm A").format(
                      "hh:mm a"
                    )
                  );
                });

                if (creditHistory) {
                  repaid =
                    parseFloat(repaid) + parseFloat(creditHistory.amountPaid);
                }
              }
            });
          } else if (fullyReturned) {
            fullyReturnedTotal += parseFloat(data.amountPaid);
          }
        }
      }
    });
    salesReturn = parseFloat(repaid) + fullyReturnedTotal;

    totalSales = totalSales - repaid - fullyReturnedTotal - cancelledBills;
    totalBills = bills.length;
    const tempArr = bills;
    const arr = tempArr.filter((data, index, self) => {
      return (
        index ===
        self.findIndex((t) => {
          return t.customerPhoneNumber === data.customerPhoneNumber;
        })
      );
    });
    customerCount = arr.length;

    return {
      totalBills,
      totalSales: totalSales.toFixed(2),
      customerCount,
      salesReturn: salesReturn.toFixed(2),
      todayBills,
      todaySale,
    };
  };
  const getCustomDates = () => {
    let custom_date = {};
    if (customDate?.length > 0) {
      custom_date = {
        from: customDate[0].format("YYYY-MM-DD"),
        to: customDate[1].format("YYYY-MM-DD"),
      };
      return custom_date;
    }
    return custom_date;
  };

  useEffect(() => {
    if (shopDetails.shopId) {
      (async function () {
        const date =
          dateValue !== "custom" ? dateType(dateValue) : getCustomDates();
        await fetchDashboardBills(
          shopDetails.shopId,
          date.from,
          date.to,
          shopDetails.empId
        );
      })();
    }

    // Cleanup function to cancel any pending requests when date changes
    return () => {
      if (currentRequestRef.current) {
        currentRequestRef.current.abort();
      }
    };
  }, [shopDetails.shopId, dateValue, shopDetails.empId, customDate]);
  useEffect(() => {
    if (bills) {
      getTotalAnalytics(bills);
    }
  }, [bills]);

  // Cleanup effect for component unmount
  useEffect(() => {
    return () => {
      if (currentRequestRef.current) {
        currentRequestRef.current.abort();
      }
    };
  }, []);
  const getTotalAnalytics = (bills = []) => {
    const analyticsResult = getTotalValue(bills);

    setTotalBills(analyticsResult.totalBills);
    setCustomerCount(analyticsResult.customerCount);
    setTotalSales(analyticsResult.totalSales);
    setSalesReturn(analyticsResult.salesReturn);
    setTodayBills(analyticsResult.todayBills);
    setTodaySale(analyticsResult.todaySale);
    const tempBillArray = bills?.map((data) => {
      if (data.otherDetails) {
        return {
          loyalty: data.loyalty,
          creditHistory: data.creditHistory,
          orderType: data.orderType,
          amountPaid: data.amountPaid,
          billingDate: data.billingDate,
          balanceAmount: data.balanceAmount,
          invoiceNumber: data.invoicePrefix
            ? data.invoicePrefix + data.invoiceNumber.toString()
            : data.invoiceNumber.toString(),
          customerName: data.customerName,
          customerNumber: data.customerPhoneNumber,
          billAmount: data.amountPaid,
          billingTime: data.billingTime,
          otherDetails: data.otherDetails,
          bills3Location: data.bills3Location,
          billId: data.billId,
          billCancelled: data.billCancelled ? data.billCancelled : false,
          items: data.items,
          roundOff: data.roundOff,
          loyaltyDiscount: data.loyaltyDiscount,
          billReturn: data.billReturn ? data.billReturn : false,
        };
      } else {
        return {
          loyalty: data.loyalty,
          amountPaid: data.amountPaid,
          orderType: data.orderType,
          otherDetails: {
            discount: data.discount,
            discountType: data.discountType,
            otherCharges: [],
            productTotal: data?.productTotal,
            paymentMethod: [
              {
                method: data.paymentMethod,
              },
            ],
          },
          loyaltyDiscount: data.loyaltyDiscount,
          balanceAmount: data.balanceAmount ? data.balanceAmount : 0,
          billAmount: data.amountPaid,
          billingTime: data?.billingTime || "",
          billId: data.billId,
          billReturn: data.billReturn ? data.billReturn : false,
          billCancelled: data.billCancelled ? data.billCancelled : false,
          billingDate: data.billingDate,
          bills3Location: data.bills3Location,
          bookingId: data.bookingId,
          cameFrom: data.cameFrom,
          chargeForDelivery: data.chargeForDelivery,
          couponDiscount: data.couponDiscount,
          customerName: data.customerName,
          customerNumber: data.customerPhoneNumber,
          discount: data.discount,
          discountType: data.discountType,
          employee: data.employee,
          invoiceNumber: data.invoiceNumber
            ? data.invoicePrefix + data.invoiceNumber.toString()
            : data.invoiceNumber.toString(),
          invoicePrefix: data.invoicePrefix,
          items: data.items,
          loyalty: data.loyalty,
          notes: data.notes,
          paymentMethod: data.paymentMethod,
          productTotal: data.productTotal,
          reminder: data.reminder,
          shopAddress: data.shopAddress,
          shopAddress: data.shopAddress,
          shopName: data.shopName,
          shopPhoneNumber: data.shopPhoneNumber,
          taxAmount: data.taxAmount,
          taxRate: data.taxRate,
          tinyUrl: data.tinyUrl,
          type: data.type,
          userId10Digit: data.datauserId10Digit,
        };
      }
    });
    const result = tempBillArray.sort(
      (a, b) =>
        parseFloat(b.invoiceNumber.replace(/[^0-9]/g, "")) -
        parseFloat(a.invoiceNumber.replace(/[^0-9]/g, ""))
    );
    setBillArray(result);
  };

  const cancelBill = async () => {
    console.log("returnProductsItem", returnProductsItem);
    const isEditEnabled = returnProductsList.items.some(
      (i) => i.editEnabled === true
    );
    if (isEditEnabled) {
      alert("You can see changes by clicking  ❌ or ✅");
      return;
    }
    setCancelLoading(true);
    const isFullyReturned = returnProductsList.items.every(
      (i) => i.fullyReturned === true
    );
    if (isFullyReturned) {
      return alert("All products are fully returned");
    }
    if (returnProductsItem.length === 0) {
      setCancelLoading(false);
      return alert("Please select a product to return");
    }
    if (returnProductsList.otherDetails) {
      if (
        parseFloat(repaidAmount) &&
        returnProductsList.otherDetails.paymentMethod?.[0]?.method !== "credit"
      ) {
        // {
        //   console.log(
        //     "returnPaymentMethod",
        //     amountToBeRepaid,
        //     returnPaymentMethod
        //   );
        // }
        if (!returnPaymentMethod) {
          setCancelLoading(false);
          return alert("Please select payment method");
        }
      }
    } else {
      if (parseFloat(repaidAmount)) {
        // {
        //   console.log(
        //     "returnPaymentMethod",
        //     amountToBeRepaid,
        //     returnPaymentMethod
        //   );
        // }
        if (!returnPaymentMethod) {
          setCancelLoading(false);
          return alert("Please select payment method");
        }
      }
    }

    if (!reasonForCancellation) {
      setCancelLoading(false);
      return alert("PLease select reason for return");
    }

    if (parseFloat(creditAdjust)) {
      await clearCreditFlow();
    }

    var body = {};

    const otherChargerValues = otherCharger
      .map((i) =>
        i.tempReturned
          ? {
              ...i,
              returned: true,
              tempReturned: undefined,
            }
          : i
      )
      .filter((f) => f.returned);
    body = {
      billId: billId,
      cancelType: "return",
      reason: reasonForCancellation,
      returnProducts: returnProductsItem.map((i) => {
        return {
          ...i,
          tempCount: undefined,
          tableData: undefined,
          fullyReturned: parseFloat(i.returned) === parseFloat(i.count),
        };
      }),
      returnPaymentMethod: parseFloat(repaidAmount)
        ? returnPaymentMethod
        : "clearCredits",

      discount: overallDiscount.show ? "applied" : "removed",
      ...(otherChargerValues.length && {
        otherCharges: otherChargerValues,
      }),
      repayAmount: parseFloat(repaidAmount) ? repaidAmount : "0.00",
    };

    setCancelLoading(true);
    console.log("cancelBillBody", body);
    try {
      var res = await fetch(`${config.newApiGateway}/bill/cancelBill`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      res = await res.json();
      setCancelBillModal(false);
      const getCustomDates = () => {
        let custom_date = {};
        if (customDate?.length > 0) {
          custom_date = {
            from: customDate[0].format("YYYY-MM-DD"),
            to: customDate[1].format("YYYY-MM-DD"),
          };
          return custom_date;
        }
      };
      const date =
        dateValue !== "custom" ? dateType(dateValue) : getCustomDates();
      let data = await getDashboardData(
        shopData.shopId,
        date.from,
        date.to,
        shopData.empId
      );
      if (data !== undefined) {
        if (data.code === "ERROR") {
          return;
        }
        setTotalBills(data.data.totalBills);
        setCustomerCount(data.data.customerCount);
        setTotalSales(data.data.totalSales);
        setSalesReturn(data.data.salesReturn);
        setTodayBills(data.data.todayBills);
        setTodaySale(data.data.todaySales);
        setBills(data.data.billArray);
      }
      setSalesReturnModal(false);
      setCancelLoading(false);
      setBillId("");
      setOtherCharger([]);
      setToDefault();
    } catch (err) {
      setCancelLoading(false);
      console.error(err);
    }
  };

  function PatchedPagination(props) {
    const {
      ActionsComponent,
      onChangePage,
      onChangeRowsPerPage,
      ...tablePaginationProps
    } = props;

    return (
      <TablePagination
        {...tablePaginationProps}
        // @ts-expect-error onChangePage was renamed to onPageChange
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
        ActionsComponent={(subprops) => {
          const { onPageChange, ...actionsComponentProps } = subprops;
          return (
            // @ts-expect-error ActionsComponent is provided by material-table
            <ActionsComponent
              {...actionsComponentProps}
              onChangePage={onPageChange}
            />
          );
        }}
      />
    );
  }

  console.log("returnProductsItem", returnProductsItem);

  useEffect(() => {
    const fetchTaxsList = async (shopId) => {
      var res = await fetch(`${config.newApiGateway}/taxMaster/taxMaster`, {
        method: "POST",
        headers: {
          "x-api-key": `${config.newApiKey}`,
          "Content-type": "application/json",
        },
        body: JSON.stringify({
          action: "fetchTaxmaster",
          shopId: shopId,
        }),
      });
      res = await res.json();
      if (res.code === "ERROR") {
        return;
      }
      dispatch({
        type: "SET_TAX_LIST",
        payload: res.data,
      });
      setTaxList(res.data);
    };
    if (shopData.shopId) {
      fetchTaxsList(shopData.shopId);
    }
  }, [shopData.shopId]);

  const countChangeHandler = (qty, product) => {
    var index = returnProducts.findIndex(
      (data) => data.productId === product.productId
    );
    var productObj = {
      ...product,
      returnedCount: qty,
    };
    var filteredArr = returnProducts.filter(
      (data) => data.productId !== product.productId
    );
    filteredArr = [
      ...filteredArr.slice(0, index),
      productObj,
      ...filteredArr.slice(index),
    ];
    setReturnProducts([...filteredArr]);
  };

  const disabledDate = (current) => {
    if (!current) {
      return false;
    }
    return current && current > moment();
  };

  const dollor = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M8.43338 7.41784C8.58818 7.31464 8.77939 7.2224 9 7.15101L9.00001 8.84899C8.77939 8.7776 8.58818 8.68536 8.43338 8.58216C8.06927 8.33942 8 8.1139 8 8C8 7.8861 8.06927 7.66058 8.43338 7.41784Z"
        fill="#fff"
      ></path>
      <path
        d="M11 12.849L11 11.151C11.2206 11.2224 11.4118 11.3146 11.5666 11.4178C11.9308 11.6606 12 11.8861 12 12C12 12.1139 11.9308 12.3394 11.5666 12.5822C11.4118 12.6854 11.2206 12.7776 11 12.849Z"
        fill="#fff"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM11 5C11 4.44772 10.5523 4 10 4C9.44772 4 9 4.44772 9 5V5.09199C8.3784 5.20873 7.80348 5.43407 7.32398 5.75374C6.6023 6.23485 6 7.00933 6 8C6 8.99067 6.6023 9.76515 7.32398 10.2463C7.80348 10.5659 8.37841 10.7913 9.00001 10.908L9.00002 12.8492C8.60902 12.7223 8.31917 12.5319 8.15667 12.3446C7.79471 11.9275 7.16313 11.8827 6.74599 12.2447C6.32885 12.6067 6.28411 13.2382 6.64607 13.6554C7.20855 14.3036 8.05956 14.7308 9 14.9076L9 15C8.99999 15.5523 9.44769 16 9.99998 16C10.5523 16 11 15.5523 11 15L11 14.908C11.6216 14.7913 12.1965 14.5659 12.676 14.2463C13.3977 13.7651 14 12.9907 14 12C14 11.0093 13.3977 10.2348 12.676 9.75373C12.1965 9.43407 11.6216 9.20873 11 9.09199L11 7.15075C11.391 7.27771 11.6808 7.4681 11.8434 7.65538C12.2053 8.07252 12.8369 8.11726 13.254 7.7553C13.6712 7.39335 13.7159 6.76176 13.354 6.34462C12.7915 5.69637 11.9405 5.26915 11 5.09236V5Z"
        fill="#fff"
      ></path>
    </svg>,
  ];
  const profile = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z"
        fill="#fff"
      ></path>
      <path
        d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z"
        fill="#fff"
      ></path>
      <path
        d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z"
        fill="#fff"
      ></path>
      <path
        d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z"
        fill="#fff"
      ></path>
    </svg>,
  ];
  const heart = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.17157 5.17157C4.73367 3.60948 7.26633 3.60948 8.82843 5.17157L10 6.34315L11.1716 5.17157C12.7337 3.60948 15.2663 3.60948 16.8284 5.17157C18.3905 6.73367 18.3905 9.26633 16.8284 10.8284L10 17.6569L3.17157 10.8284C1.60948 9.26633 1.60948 6.73367 3.17157 5.17157Z"
        fill="#fff"
      ></path>
    </svg>,
  ];
  const cart = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2C7.79086 2 6 3.79086 6 6V7H5C4.49046 7 4.06239 7.38314 4.00612 7.88957L3.00612 16.8896C2.97471 17.1723 3.06518 17.455 3.25488 17.6669C3.44458 17.8789 3.71556 18 4 18H16C16.2844 18 16.5554 17.8789 16.7451 17.6669C16.9348 17.455 17.0253 17.1723 16.9939 16.8896L15.9939 7.88957C15.9376 7.38314 15.5096 7 15 7H14V6C14 3.79086 12.2091 2 10 2ZM12 7V6C12 4.89543 11.1046 4 10 4C8.89543 4 8 4.89543 8 6V7H12ZM6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10ZM13 9C12.4477 9 12 9.44772 12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9Z"
        fill="#fff"
      ></path>
    </svg>,
  ];

  const dashboardCount = useMemo(() => {
    const date =
      dateValue !== "custom" ? dateType(dateValue) : getCustomDates();
    const currentDate = moment().format("YYYY-MM-DD");
    const analyticsTitle =
      currentDate === date.to && date.from === currentDate
        ? "Today's"
        : "Total";
    const dialCode = country.dialCode || "+91";
    const currencyIcon = {
      "+91": faIndianRupeeSign,
      "+63": faPesoSign,
      "+1": faDollarSign,
    };
    const count = [
      {
        today: `${analyticsTitle} Sales`,
        title: (
          <div
            style={{
              whiteSpace: "nowrap",
            }}
          >
            {currencyIcon[dialCode] ? (
              <FontAwesomeIcon
                style={{
                  fontSize: 24,
                  fontWeight: 800,
                }}
                icon={currencyIcon[dialCode]}
              />
            ) : (
              <span style={{ fontSize: 24, color: "#000" }}>
                {country.CurrencySymbol}
              </span>
            )}

            <CountUp
              style={{
                all: "inherit",
                display: "inline-block",
              }}
              separator=","
              end={totalSales}
            />
          </div>
        ),
        icon: (
          <FontAwesomeIcon
            style={{
              fontSize: 20,
            }}
            icon={currencyIcon[dialCode]}
          />
        ),
        bnb: "bnb2",
      },
      {
        today: `${analyticsTitle} Customer`,
        title: (
          <CountUp
            style={{
              all: "inherit",
              display: "inline-block",
            }}
            end={customerCount}
          />
        ),
        icon: profile,
        bnb: "bnb2",
      },
      {
        today: `${analyticsTitle} Bills`,
        title: (
          <CountUp
            style={{
              all: "inherit",
              display: "inline-block",
            }}
            end={totalBills}
          />
        ),
        icon: heart,
        bnb: "redtext",
      },
      {
        today: `${analyticsTitle} Sales Return`,
        title: (
          <div
            style={{
              whiteSpace: "nowrap",
            }}
          >
            {currencyIcon[dialCode] ? (
              <FontAwesomeIcon
                style={{
                  fontSize: 24,
                  fontWeight: 800,
                }}
                icon={currencyIcon[dialCode]}
              />
            ) : (
              <span style={{ fontSize: 24, color: "#000" }}>
                {country.CurrencySymbol}
              </span>
            )}
            <CountUp
              style={{
                all: "inherit",
                display: "inline-block",
              }}
              end={salesReturn}
            />
          </div>
        ),
        icon: cart,
        bnb: "bnb2",
      },
    ];

    return count;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesReturn, totalBills, totalSales, customerCount, dateValue]);

  const repaidAmount = useMemo(() => {
    const loyaltyDiscount = returnProductsList.loyaltyDiscount;
    const loyaltyDiscountPercentage =
      parseFloat(returnProductsList.amountPaid) /
      (parseFloat(returnProductsList.amountPaid) +
        parseFloat(loyaltyDiscount || 0));
    console.log("loyaltyDiscountPercentage", loyaltyDiscountPercentage);
    if (loyaltyDiscountPercentage) {
      return amountToBeRepaid * loyaltyDiscountPercentage;
    } else {
      return amountToBeRepaid;
    }
  }, [
    returnProductsList.amountPaid,
    returnProductsList.loyaltyDiscount,
    amountToBeRepaid,
  ]);

  console.log("repaidAmount12121", repaidAmount);

  const tableColumns = [
    {
      title: "Date",
      key: "Date",
      sorter: (a, b) => {
        return (
          moment(b.billingDate, "YYYY-MM-DD").toDate() -
          moment(a.billingDate, "YYYY-MM-DD").toDate()
        );
      },
      cellStyle: {
        textAlign: "center",
      },
      headerStyle: {
        textAlign: "center",
      },
      render: (rowData) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div>
              {moment(rowData.billingDate, "YYYY-MM-DD").format("DD-MM-YYYY")}
            </div>
            <div style={{ color: "red" }}> {checkReturnedItems(rowData)}</div>
          </div>
        );
      },
    },
    {
      title: " Time",
      key: "billingTime",
      dataIndex: "billingTime",
      cellStyle: {
        textAlign: "center",
      },
      headerStyle: {
        textAlign: "center",
      },
      render: (billingTime) => {
        return <span>{billingTime}</span>;
      },
    },
    {
      title: "Invoice Number",
      key: "Invoice",
      dataIndex: "invoiceNumber",
      cellStyle: {
        textAlign: "center",
      },
      headerStyle: {
        textAlign: "center",
      },
      sorter: (a, b) => {
        if (
          typeof a.invoiceNumber === "number" &&
          typeof b.invoiceNumber === "number"
        ) {
          return a.invoiceNumber - b.invoiceNumber;
        } else if (
          typeof a.invoiceNumber === "number" &&
          typeof b.invoiceNumber !== "number"
        ) {
          return -1;
        } else if (
          typeof a.invoiceNumber !== "number" &&
          typeof b.invoiceNumber === "number"
        ) {
          return 1;
        } else {
          return a.invoiceNumber > b.invoiceNumber ? 1 : -1;
        }
      },
    },
    {
      title: "Customer Name",
      dataIndex: "customerName",
      key: "customerName",
      cellStyle: {
        textAlign: "center",
      },
      headerStyle: {
        textAlign: "center",
      },
    },
    {
      title: "Customer Number",
      dataIndex: "customerNumber",
      key: "customerNumber",
      cellStyle: {
        textAlign: "center",
      },
      headerStyle: {
        textAlign: "center",
      },
      render: (customerNumber) => {
        return <span>{customerNumber}</span>;
      },
    },
    {
      title: "Bill Amount",
      key: "billAmount",
      dataIndex: "billAmount",
      cellStyle: {
        textAlign: "center",
        zIndex: "0 !important",
      },
      headerStyle: {
        textAlign: "center",
      },
      sorter: (a, b) => {
        return parseFloat(a.billAmount) - parseFloat(b.billAmount);
      },
      render: (billAmount) => {
        return <span>{currencyFormatter(billAmount)}</span>;
      },
    },
    {
      title: "Actions",
      cellStyle: {
        textAlign: "center",
      },
      key: "Actions",
      headerStyle: {
        textAlign: "center",
      },
      render: (data) => {
        return (
          <Dropdown
            getPopupContainer={(trigger) => trigger.parentNode}
            overlay={menu(data)}
            placement="left"
            arrow
          >
            <EllipsisOutlined
              style={{
                fontSize: "2rem",
                transform: "rotate(90deg)",
                cursor: "pointer",
                padding: "1rem",
              }}
            />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <>
      <div
        id="printThermal"
        style={{
          overflow: "hidden",
          height: "0px",
        }}
      >
        <>
          <div>
            {Object.keys(thermalPayload).length > 0 && (
              <InvoiceTemplate ref={printRef} data={thermalPayload} />
            )}
          </div>
        </>
      </div>
      {isLoaded ? (
        <div>
          <Row className="rowgap-vbox" gutter={[24, 0]}>
            {dashboardCount.map((c, index) => (
              <Col
                key={index}
                xs={24}
                sm={24}
                md={12}
                lg={6}
                xl={6}
                className="mb-24"
              >
                <AnalyticsCard label={c.title} value={c.today} icon={c.icon} />
              </Col>
            ))}
          </Row>
          <div className="goto-billing-button">
            <Button
              onClick={() => {
                props.history.push("/billing");
              }}
              type="primary"
            >
              GENERATE BILL
            </Button>
          </div>

          <div>
            <div style={{ width: "100%", height: "100%" }}>
              <div style={{ marginTop: "80px" }}>
                {/* <MaterialTable
                  style={{
                    position: "static",
                  }}
                  columns={
                    [
                    {
                      title: "Date",
                      dataIndex: "billingDate",
                      cellStyle: {
                        textAlign: "center",
                      },
                      headerStyle: {
                        textAlign: "center",
                      },
                      render: (rowData) => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            <div>
                              {" "}
                              {moment(rowData.billingDate).format("DD-MM-YYYY")}
                            </div>
                            <div style={{ color: "red" }}>
                              {" "}
                              {checkReturnedItems(rowData)}
                            </div>
                          </div>
                        );
                      },
                    },
                    {
                      title: "Invoice Number",
                      field: "invoiceNumber",
                      cellStyle: {
                        textAlign: "center",
                      },
                      headerStyle: {
                        textAlign: "center",
                      },

                      render: (rowData) => {
                        return (
                          <span>
                            {rowData.invoicePrefix}
                            {rowData.invoiceNumber}
                          </span>
                        );
                      },
                    },
                    {
                      title: "Customer Name ",
                      field: "customerName",
                      cellStyle: {
                        textAlign: "center",
                      },
                      headerStyle: {
                        textAlign: "center",
                      },
                    },
                    {
                      title: "Customer Number",
                      field: "customerNumber",
                      cellStyle: {
                        textAlign: "center",
                      },
                      headerStyle: {
                        textAlign: "center",
                      },
                      render: (rowData) => {
                        return <span>{rowData.customerNumber}</span>;
                      },
                    },
                    {
                      title: "Bill Amount",
                      field: "billAmount",
                      cellStyle: {
                        textAlign: "center",
                        zIndex: "0 !important",
                      },
                      headerStyle: {
                        textAlign: "center",
                      },
                      render: (rowData) => {
                        return (
                          <span>{currencyFormatter(rowData.billAmount)}</span>
                        );
                      },
                    },
                    {
                      title: "Actions",
                      cellStyle: {
                        textAlign: "center",
                      },
                      headerStyle: {
                        textAlign: "center",
                      },
                      render: (data) => {
                        return (
                          <Dropdown overlay={menu(data)} placement="left" arrow>
                            <EllipsisOutlined
                              style={{
                                fontSize: "2rem",
                                transform: "rotate(90deg)",
                                cursor: "pointer",
                                padding: "1rem",
                              }}
                            />
                          </Dropdown>
                        );
                      },
                    },
                  ]}
                  title={<div>Recent Bills </div>}
                  icons={tableIcons}
                  data={billArray}
                  components={{
                    Pagination: PatchedPagination,
                  }}
                /> */}
                <Table
                  title={"Recent Bill"}
                  data={billArray}
                  columns={tableColumns}
                  loading={isFetchLoading}
                  style={{
                    minHeight: 410,
                  }}
                  emptyContainerStyle={{
                    height: "calc(100vh - 410px)",
                  }}
                  extraAction={
                    <>
                      {dateValue !== "custom" && (
                        <Select
                          value={dateValue}
                          onChange={handleDateChange}
                          defaultValue="today"
                          style={{
                            width: "200px",
                          }}
                        >
                          <Select.Option value="today">Today</Select.Option>
                          <Select.Option value="week">
                            Last 7 days
                          </Select.Option>
                          <Select.Option value="month">
                            Last 30 days
                          </Select.Option>
                          <Select.Option value="custom">
                            Custom Date
                          </Select.Option>
                        </Select>
                      )}
                      {dateValue === "custom" && (
                        <RangePicker
                          value={customDate}
                          disabledDate={disabledDate}
                          onChange={handleDateRange}
                          open={customDate?.length === 2 ? false : true}
                        />
                      )}
                    </>
                  }
                />
              </div>
            </div>
          </div>
          <Modal
            show={cancelBillModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={() => {
              setCancelBillModal(false);
              setCancelType("");
            }}
          >
            <Modal.Header closeButton>
              <div>
                <h3 style={{ color: "#EF4667" }}>Cancel Bill</h3>
              </div>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <div className="row">
                  <div className="col-7">
                    <div className="row">
                      <div className="col-8">
                        <label>Choose Reason for Cancellation</label>
                        {/* <Form.Control
                          type="text"
                          placeholder="Choose Reason for Cancellation"
                        /> */}
                      </div>
                      <br />
                      <div className="col-8">
                        <Form.Control
                          as="select"
                          value={reasonForCancellation}
                          onChange={(e) =>
                            setReasonForCancellation(e.target.value)
                          }
                        >
                          <option value="" disabled>
                            Choose cancellation reason
                          </option>
                          <option value="Duplicate invoice number">
                            Duplicate invoice number
                          </option>
                          <option value="Order Cancellation">
                            Order Cancellation
                          </option>
                          <option value="Product returns">
                            Product returns
                          </option>
                          <option value="Others">Others</option>
                        </Form.Control>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ height: 15 }}></div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="cancelButton"
                style={{
                  border: "0",
                  fontSize: "18px",
                  backgroundColor: "transparent",
                  color: "#5194c6",
                }}
                onClick={() => {
                  setCancelBillModal(false);
                  setCancelType("");
                }}
              >
                Cancel{" "}
              </button>
              <button
                className="addAddrButton"
                disabled={cancelLoading}
                style={{
                  border: "0",
                  backgroundColor: "#ef4667",
                  color: "#fff",
                  fontSize: "15px",
                  fontWeight: "600",
                  borderRadius: "6px",
                  padding: "10px 14px",
                  cursor: "pointer",
                }}
                onClick={() => cancelBill()}
              >
                Cancel Bill
                {cancelLoading && (
                  <Spinner
                    variant="primary"
                    animation="border"
                    size="sm"
                    style={{
                      marginLeft: "10px",
                      backgroundColor: "#fff",
                    }}
                  />
                )}
              </button>
            </Modal.Footer>
          </Modal>
          <Modal
            show={returnItemModal}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            {Object.keys(returnProductsList).length > 0 ? (
              <div
                style={{
                  minHeight: "500px",
                }}
                className="returnItemsMain"
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div></div>
                  <div
                    onClick={() => {
                      setReturnItemModal(false);
                      setCancelType("");
                      setReturnProducts([]);
                      setReturnProductsItem([]);
                      setOverallDiscount({
                        amount: 0,
                        show: true,
                        returned: false,
                      });
                      setOtherCharger([]);
                      setBillId("");
                      setSelectAllItems(false);
                      // setAdjustingFromDiscount("");
                    }}
                    className="returnItemModalClosure"
                  >
                    <MdOutlineClose />
                  </div>
                </div>
                <div className="returnItemsHeader">
                  <div style={{ color: "#EF4667", fontSize: "22PX" }}>
                    Return Products
                  </div>
                  {contextHolder}
                  <div>
                    {returnProductsList.billReturn && (
                      <Popover
                        content={
                          <div
                            style={{
                              width: 400,
                            }}
                          >
                            {returnProductsList.billReturn.map((i) => {
                              return (
                                <div>
                                  <div>Date:{i.returnedData}</div>
                                  <Row>
                                    <Col span={12}>
                                      <Typography.Text strong>
                                        Item Name
                                      </Typography.Text>
                                    </Col>
                                    <Col span={6}>
                                      <Typography.Text strong>
                                        {" "}
                                        Quantity{" "}
                                      </Typography.Text>
                                    </Col>
                                    <Col span={6}>
                                      <Typography.Text strong>
                                        Amount
                                      </Typography.Text>
                                    </Col>
                                    {i.returnItem.map((prod) => {
                                      const product =
                                        returnProductsList.items.find(
                                          (item) =>
                                            item.productId === prod.productId
                                        );

                                      if (i.repayMethod === "clearCredits") {
                                        console.log(
                                          "repayMethod231",
                                          i.repayMethod,
                                          returnProductsList.creditHistory
                                        );
                                        const creditHistory =
                                          returnProductsList.creditHistory?.find(
                                            (f) => {
                                              console.log(
                                                "updatedTime",
                                                f.updatedTime,
                                                moment(
                                                  i.returnedData,
                                                  "YYYY-MM-DD hh:mm A"
                                                ).format("hh:mm a")
                                              );
                                              return (
                                                f.updatedTime ===
                                                moment(
                                                  i.returnedData,
                                                  "YYYY-MM-DD hh:mm A"
                                                ).format("hh:mm a")
                                              );
                                            }
                                          );

                                        if (creditHistory) {
                                          i.repayAmount = parseFloat(
                                            creditHistory.amountPaid
                                          );
                                        }
                                      }
                                      return (
                                        <>
                                          <Col span={12}>
                                            {product.productName}
                                          </Col>
                                          <Col span={6}>
                                            {prod.returnedCount}
                                          </Col>
                                          <Col span={6}>
                                            {currencyFormatter(
                                              parseFloat(product.perQuantity) *
                                                parseFloat(prod.returnedCount)
                                            )}
                                          </Col>
                                        </>
                                      );
                                    })}

                                    {i.discount === "removed" && (
                                      <Col span={24}>
                                        <Typography.Text strong>
                                          Discount:{" "}
                                        </Typography.Text>
                                        <Typography.Text>
                                          {returnProductsList.otherDetails
                                            .discountType === "percentage" ? (
                                            <span>
                                              {currencyFormatter(
                                                (parseFloat(
                                                  returnProductsList
                                                    .otherDetails.productTotal
                                                ) *
                                                  parseFloat(
                                                    returnProductsList
                                                      .otherDetails.discount
                                                  )) /
                                                  100
                                              )}
                                              {"  "}
                                              Percentage(
                                              {
                                                returnProductsList.otherDetails
                                                  .discount
                                              }
                                              %)
                                            </span>
                                          ) : (
                                            currencyFormatter(
                                              returnProductsList.otherDetails
                                                .discount
                                            )
                                          )}
                                          {"  "}
                                          {i.discount === "removed"
                                            ? "Removed"
                                            : "Applied"}
                                        </Typography.Text>
                                      </Col>
                                    )}
                                    <Col span={24}>
                                      <Typography.Text strong>
                                        Repay Amount :{" "}
                                      </Typography.Text>
                                      <Typography.Text>
                                        {currencyFormatter(i.repayAmount)}(
                                        {i.repayMethod})
                                      </Typography.Text>
                                    </Col>
                                    {i.otherCharges && (
                                      <>
                                        {i.otherCharges.map((item) => {
                                          return (
                                            <Col span={24}>
                                              <Typography.Text strong>
                                                {item.name} :
                                              </Typography.Text>
                                              <Typography.Text>
                                                {currencyFormatter(item.price)}
                                              </Typography.Text>
                                            </Col>
                                          );
                                        })}
                                      </>
                                    )}

                                    <Divider
                                      style={{
                                        margin: 2,
                                      }}
                                    />
                                  </Row>
                                </div>
                              );
                            })}
                            {returnProductsList.billReturn?.every(
                              (i) => i.discount === "applied"
                            ) && (
                              <Col span={24}>
                                <Typography.Text strong>
                                  Discount:{" "}
                                </Typography.Text>
                                <Typography.Text>
                                  {returnProductsList.otherDetails
                                    .discountType === "percentage" ? (
                                    <span>
                                      {currencyFormatter(
                                        (parseFloat(
                                          returnProductsList.otherDetails
                                            .productTotal
                                        ) *
                                          parseFloat(
                                            returnProductsList.otherDetails
                                              .discount
                                          )) /
                                          100
                                      )}
                                      {"  "}
                                      Percentage(
                                      {returnProductsList.otherDetails.discount}
                                      %)
                                    </span>
                                  ) : (
                                    currencyFormatter(
                                      returnProductsList.otherDetails.discount
                                    )
                                  )}
                                </Typography.Text>
                              </Col>
                            )}

                            <Col span={24}>
                              <Typography.Text strong>
                                Sales Return of this bill:{" "}
                              </Typography.Text>
                              <Typography.Text>
                                {currencyFormatter(
                                  returnProductsList.billReturn.reduce(
                                    (acc, curr) =>
                                      acc + parseFloat(curr.repayAmount),
                                    0
                                  )
                                )}
                              </Typography.Text>
                            </Col>
                            <Col span={24}>
                              <Typography.Text strong>
                                Total Sales of this bill :{" "}
                              </Typography.Text>
                              <Typography.Text>
                                {currencyFormatter(
                                  parseFloat(returnProductsList.billAmount) -
                                    parseFloat(
                                      returnProductsList.billReturn.reduce(
                                        (acc, curr) =>
                                          acc + parseFloat(curr.repayAmount),
                                        0
                                      )
                                    )
                                )}
                              </Typography.Text>
                            </Col>
                          </div>
                        }
                        title={
                          <Typography.Title
                            level={5}
                            style={{
                              alignItems: "center",
                            }}
                          >
                            Returned History
                          </Typography.Title>
                        }
                        getPopupContainer={(trigger) => trigger.parentNode}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "4px",
                          }}
                        >
                          <Button
                            style={{
                              fontWeight: 500,
                              color: "#5194C6",
                              fontSize: "21px",
                              paddingRight: 0,
                            }}
                            type="link"
                          >
                            History
                          </Button>
                          <DownOutlined size={14} />
                        </div>
                      </Popover>
                    )}
                  </div>
                  <div
                    style={{
                      color: "#5194C6",
                      fontSize: "21px",
                      marginRight: "15px",
                    }}
                  >
                    {returnProductsList.balanceAmount > 0
                      ? `Credit Amount :  ${returnProductsList.balanceAmount}`
                      : "Credit Amount :  0.00"}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        color: "#5194C6",
                        fontSize: "21px",
                        marginRight: "15px",
                      }}
                    >
                      Invoice No : {returnProductsList.invoiceNumber}
                    </div>
                  </div>
                </div>
                <div className="billedProductsListSection">
                  {/* {returnProductsList.items.map((data) => {
                    return (
                      <div>
                        <div>
                          <input type="checkBox" />
                        </div>
                        <div>{data.productName}</div>
                      </div>
                    );
                  })} */}
                  <MaterialTable
                    columns={[
                      {
                        title: "Product Name",
                        field: "productName",
                        render: (data) => {
                          return (
                            <div>
                              <div>{data.productName}</div>
                              {data.fullyReturned && (
                                <div style={{ color: "red" }}>
                                  Already Returned
                                </div>
                              )}

                              {(invoiceSettings.itemDiscount ||
                                invoiceSettings.itemLevelTax) && (
                                <div>
                                  {(data.discount || data.taxId) && (
                                    <div
                                      style={{ color: "#008080", fontSize: 12 }}
                                    >
                                      This product item has a tax/discount
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        },
                      },
                      {
                        title: `MRP(${country.CurrencySymbol})`,
                        field: "productMrp",
                      },
                      {
                        title: `Selling Price(${country.CurrencySymbol})`,
                        field: "productPrice",
                      },
                      {
                        title: "Quantity",
                        field: "count",
                        render: (data) => {
                          return <div>{data.count}</div>;
                        },
                      },
                      {
                        title: "Action",
                        render: (data) => {
                          return (
                            <EditableQuantity
                              data={data}
                              setReturnProductsList={setReturnProductsList}
                              setReturnProductsItem={setReturnProductsItem}
                            />
                          );
                        },
                      },
                      {
                        title: "Returned Count",
                        field: "tempReturnedCount",
                        render: (data) => {
                          return (
                            <span>
                              {data.tempReturnedCount
                                ? data.tempReturnedCount
                                : "-"}
                            </span>
                          );
                        },
                      },
                      // {
                      //   title: "Number of returns",
                      //   render: (data) => {
                      //     return (
                      //       <form>
                      //         <input
                      //           onChange={(e) =>
                      //             countChangeHandler(e.target.value, data)
                      //           }
                      //           value={data.returnedCount}
                      //           type="number"
                      //           disabled={
                      //             parseFloat(data.count) === 1 ||
                      //             parseFloat(data.count) -
                      //               parseFloat(
                      //                 data.returned ? data.returned : 0
                      //               ) ===
                      //               0
                      //           }
                      //           max={data.returnedCount}
                      //         />
                      //       </form>
                      //     );
                      //   },
                      // },
                    ]}
                    icons={tableIcons}
                    title={billFullyReturned ? "Bill Returned Fully" : ""}
                    data={returnProductsList.items}
                    components={{
                      Pagination: PatchedPagination,
                    }}
                    options={{
                      showSelectAllCheckbox: !returnProductsList.items.every(
                        (i) => i.fullyReturned === true
                      ),
                      selection: true,
                      selectionProps: (rowData) => {
                        return {
                          disabled:
                            parseFloat(rowData.count) ===
                            parseFloat(rowData.tempReturnedCount),
                        };
                      },
                    }}
                    onSelectionChange={(rows, rowData) => {
                      if (rowData) {
                        if (rowData.tableData.checked) {
                          setReturnProductsItem((prev) => {
                            const isExist = prev.some(
                              (i) => i.productId === rowData.productId
                            );

                            if (isExist) {
                              const filtered = prev.filter(
                                (i) => i.productId !== rowData.productId
                              );
                              return [
                                ...filtered,
                                {
                                  ...rowData,
                                  tempCount:
                                    parseFloat(rowData.count) -
                                    parseFloat(rowData.tempReturnedCount || 0),
                                  returned: parseFloat(rowData.count),
                                },
                              ];
                            }
                            return [
                              ...prev,
                              {
                                ...rowData,
                                returned: parseFloat(rowData.count),
                              },
                            ];
                          });
                        } else if (!rowData.tableData.checked) {
                          setReturnProductsItem((prev) => {
                            const isExist = prev.some(
                              (i) => i.productId === rowData.productId
                            );
                            if (isExist) {
                              const filtered = prev.filter(
                                (i) => i.productId !== rowData.productId
                              );
                              return filtered;
                            }
                            return prev;
                          });
                        }
                        setReturnProductsList((prev) => {
                          return {
                            ...prev,
                            items: prev.items.map((i) => {
                              if (
                                rowData.productId === i.productId &&
                                rowData.tableData.checked
                              ) {
                                return {
                                  ...i,
                                  tempCount:
                                    parseFloat(i.count) -
                                    parseFloat(i.tempReturnedCount || 0),
                                  returned: rowData.count,
                                };
                              } else if (
                                rowData.productId === i.productId &&
                                !rowData.tableData.checked
                              ) {
                                return {
                                  ...i,
                                  tempCount:
                                    parseFloat(i.count) -
                                    parseFloat(i.tempReturnedCount || 0),
                                  returned: rowData.tempReturnedCount,
                                };
                              }
                              return i;
                            }),
                          };
                        });
                      } else if (rows.length > 0) {
                        const isChecked = rows.every(
                          (i) => i.tableData.checked === true
                        );
                        if (isChecked) {
                          setSelectAll(true);
                        }
                        setReturnProductsList((prev) => {
                          return {
                            ...prev,
                            items: rows.map((i) => {
                              if (i.tableData.checked) {
                                return {
                                  ...i,
                                  tempCount:
                                    parseFloat(i.count) -
                                    parseFloat(i.tempReturnedCount || 0),
                                };
                              }
                              return i;
                            }),
                          };
                        });
                        setReturnProductsItem((prev) => {
                          return rows.map((i) => {
                            return {
                              ...i,
                              tempCount:
                                parseFloat(i.count) -
                                parseFloat(i.tempReturnedCount || 0),
                              returned: parseFloat(i.count),
                            };
                          });
                        });
                      } else if (rows.length === 0) {
                        setSelectAll(false);
                        setReturnProductsList((prev) => {
                          return {
                            ...prev,
                            items: prev.items.map((i) => {
                              return {
                                ...i,
                                tempCount:
                                  parseFloat(i.count) -
                                  parseFloat(i.tempReturnedCount || 0),
                              };
                            }),
                          };
                        });
                        setReturnProductsItem([]);
                      }

                      // returnProductsList.billReturn.forEach((item) => {
                      //   item.returnItem.forEach((returnItem) => {
                      //     if (
                      //       returnProducts.hasOwnProperty(returnItem.productId)
                      //     ) {
                      //       returnedProductsByGroup[
                      //         returnItem.productId
                      //       ].returnedCount =
                      //         parseFloat(
                      //           returnedProductsByGroup[returnItem.productId]
                      //             .returnedCount
                      //         ) + parseFloat(returnItem.returnedCount);
                      //     } else {
                      //       returnedProductsByGroup[returnItem.productId] =
                      //         returnItem;
                      //     }
                      //   });
                      // });
                      // const returnedProducts = Object.values(
                      //   returnedProductsByGroup
                      // );
                      // console.log("returnedProducts", returnedProducts);
                      // console.log("rows", rows);
                      // setReturnProductsList((prev) => ({
                      //   ...prev,
                      //   items: prev.items.map((i) => {
                      //     const findProduct = rows.find(
                      //       (fData) => fData.productId === i.productId
                      //     );
                      //     const hasQuantityWithReturned = returnedProducts.find(
                      //       (fData) => fData.productId === i.productId
                      //     );

                      //     if (hasQuantityWithReturned) {
                      //       const availableQuantity =
                      //         parseFloat(i.count) -
                      //         parseFloat(hasQuantityWithReturned.returnedCount);
                      //       console.log(
                      //         "hasQuantityWithReturned",
                      //         hasQuantityWithReturned,
                      //         availableQuantity
                      //       );
                      //       if (availableQuantity > 0) {
                      //         return {
                      //           ...i,
                      //           count: availableQuantity,
                      //           returned: hasQuantityWithReturned.returned,
                      //         };
                      //       } else {
                      //         return i;
                      //       }
                      //     }
                      //     if (findProduct) {
                      //       return {
                      //         ...i,
                      //         count: i.returned ? findProduct.count : 0,
                      //         returned: i.returned ? i.returned : i.count,
                      //       };
                      //     }
                      //     return {
                      //       ...i,
                      //       count: i.returned
                      //         ? parseFloat(i.count) + parseFloat(i.returned)
                      //         : parseFloat(i.count),
                      //       returned: 0,
                      //     };
                      //   }),
                      // }));
                    }}
                  />
                </div>
                <div className="returnModalFooter">
                  <div>
                    <div className="returnPaymentSelect">
                      <Form.Control
                        as="select"
                        value={returnPaymentMethod}
                        onChange={(e) => setReturnPaymentMethod(e.target.value)}
                        disabled={
                          parseFloat(repaidAmount) === 0 ||
                          returnProductsItem.length === 0
                        }
                      >
                        <option value="choose">Choose Payment Method</option>
                        <option value="cash">Cash</option>
                        <option value="upi">Upi</option>
                      </Form.Control>
                    </div>
                    <div className="returnReasonSelect">
                      <Form.Control
                        as="select"
                        value={reasonForCancellation}
                        onChange={(e) =>
                          setReasonForCancellation(e.target.value)
                        }
                        disabled={billFullyReturned}
                      >
                        <option value="" disabled>
                          Choose Return Reason
                        </option>
                        <option value="Duplicate invoice number">
                          Duplicate invoice number
                        </option>
                        <option value="Order Cancellation">
                          Order Cancellation
                        </option>
                        <option value="Product returns">Product returns</option>
                        <option value="Others">Others</option>
                      </Form.Control>
                    </div>
                  </div>
                  <div className="repayAmountContainer">
                    {console.log("returnProductsList", returnProductsList)}
                    <div>
                      <div>Total Return Amount:</div>
                      <div>Adjusted From Credit:</div>
                      {returnProductsList?.loyalty && (
                        <div>Loyalty Discount:</div>
                      )}

                      <span
                        style={{
                          display: returnProductsList.roundOff
                            ? "inline-block"
                            : "none",
                        }}
                      >
                        Round Off
                      </span>

                      {(!!overallDiscount.amount ||
                        overallDiscount.returned) && (
                        <div
                          style={
                            overallDiscount.returned
                              ? {
                                  display: "none",
                                }
                              : {
                                  display: "flex",
                                  alignItems: "center",
                                }
                          }
                        >
                          <span
                            style={
                              !overallDiscount.show || overallDiscount.returned
                                ? {
                                    textDecoration: "line-through",
                                  }
                                : {}
                            }
                          >
                            Discount Amount
                          </span>

                          {!selectAll && (
                            <div>
                              {overallDiscount.show ? (
                                <button
                                  disabled={
                                    repaidAmount <= overallDiscount.amount
                                  }
                                  style={{
                                    height: "20px",
                                    fontSize: "10px",
                                    borderRadius: "14px",
                                    padding: "0 4px",
                                    border: "1px solid #ccc",
                                    background: "transparent",
                                  }}
                                  onClick={() => {
                                    setOverallDiscount((prev) => ({
                                      ...prev,
                                      show: false,
                                    }));
                                    setAmountToBeRepaid(
                                      repaidAmount -
                                        parseFloat(overallDiscount.amount)
                                    );
                                  }}
                                >
                                  Remove
                                </button>
                              ) : (
                                <>
                                  {" "}
                                  <button
                                    disabled={overallDiscount.returned}
                                    style={{
                                      height: "20px",
                                      fontSize: "10px",
                                      borderRadius: "14px",
                                      padding: "0 8px",
                                      border: "1px solid #ccc",
                                      background: "transparent",
                                    }}
                                    onClick={() => {
                                      setOverallDiscount((prev) => ({
                                        ...prev,
                                        show: true,
                                      }));
                                      setAmountToBeRepaid(
                                        repaidAmount +
                                          parseFloat(overallDiscount.amount)
                                      );
                                    }}
                                  >
                                    Add
                                  </button>
                                  <span>
                                    {overallDiscount.returned
                                      ? "(Non-Refund)"
                                      : ""}
                                  </span>
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                      {returnItemModal &&
                        otherCharger.map((i) => {
                          return parseFloat(i.price) ? (
                            <div
                              style={
                                i.returned
                                  ? {
                                      display: "none",
                                      cursor: "not-allowed",
                                    }
                                  : {}
                              }
                            >
                              <span
                                style={
                                  !i.tempReturned
                                    ? {
                                        textDecoration: "line-through",
                                      }
                                    : {}
                                }
                              >
                                {i.name}
                              </span>
                              {i.tempReturned ? (
                                <button
                                  style={{
                                    height: "20px",
                                    fontSize: "10px",
                                    borderRadius: "14px",
                                    padding: "0 4px",
                                    border: "1px solid #ccc",
                                    background: "transparent",
                                  }}
                                  onClick={() => {
                                    setOtherCharger((prev) => {
                                      return prev.map((item) =>
                                        item.id === i.id
                                          ? {
                                              ...item,
                                              returned: false,
                                              tempReturned: false,
                                            }
                                          : item
                                      );
                                    });
                                    setAmountToBeRepaid(
                                      (prev) =>
                                        parseFloat(prev) - parseFloat(i.price)
                                    );
                                  }}
                                >
                                  Remove
                                </button>
                              ) : (
                                <button
                                  style={{
                                    height: "20px",
                                    fontSize: "10px",
                                    borderRadius: "14px",
                                    padding: "0 4px",
                                    border: "1px solid #ccc",
                                    background: "transparent",
                                  }}
                                  onClick={() => {
                                    setOtherCharger((prev) => {
                                      return prev.map((item) =>
                                        item.id === i.id
                                          ? {
                                              ...item,

                                              tempReturned: true,
                                            }
                                          : item
                                      );
                                    });
                                    setAmountToBeRepaid(
                                      (prev) =>
                                        parseFloat(prev) + parseFloat(i.price)
                                    );
                                  }}
                                >
                                  Add
                                </button>
                              )}
                            </div>
                          ) : null;
                        })}
                      <div>Repay Amount:</div>
                    </div>
                    <div>
                      {parseFloat(sumOfSelectedReturn).toFixed("2")}
                      <Popover
                        style={{
                          zIndex: 1000,
                        }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        content={
                          <div
                            style={{
                              width: 300,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography.Text strong>
                                Product Name
                              </Typography.Text>
                              <Typography.Text strong>Quantity</Typography.Text>
                              <Typography.Text strong>Amount</Typography.Text>
                            </div>
                            {returnProductsItem.map((i) => {
                              const perQuantity =
                                parseFloat(i.itemTotal) /
                                parseFloat(i.count || 0);
                              return (
                                <Row
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Col span={12}>
                                    <Typography.Text>
                                      {i.productName}
                                    </Typography.Text>
                                  </Col>
                                  <Col span={6}>
                                    <Typography.Text>
                                      {parseFloat(i.returned) -
                                        parseFloat(i.tempReturnedCount || 0)}
                                    </Typography.Text>
                                  </Col>
                                  <Col
                                    span={6}
                                    style={{
                                      textAlign: "right",
                                    }}
                                  >
                                    <Typography.Text>
                                      {currencyFormatter(
                                        (parseFloat(i.returned) -
                                          parseFloat(
                                            i.tempReturnedCount || 0
                                          )) *
                                          perQuantity
                                      )}
                                    </Typography.Text>
                                  </Col>
                                </Row>
                              );
                            })}
                          </div>
                        }
                        title={
                          <Typography.Title
                            level={5}
                            style={{
                              alignItems: "center",
                            }}
                          >
                            Returning Items
                          </Typography.Title>
                        }
                      >
                        <AiOutlineInfoCircle
                          style={{
                            verticalAlign: "text-top",
                            marginLeft: 4,
                          }}
                        />
                      </Popover>

                      <div
                        style={{
                          color: "rgb(81, 148, 198)",
                          fontWeight: "600",
                        }}
                      >
                        {parseFloat(creditAdjust).toFixed("2")}
                      </div>
                      {returnProductsList?.loyalty && (
                        <div
                          style={{
                            fontWeight: "600",
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <span
                            style={
                              loyaltyCouponRedeem
                                ? {
                                    textDecoration: "line-through",
                                  }
                                : {}
                            }
                          >
                            {returnProductsList.loyalty?.couponDetails}(
                            {returnProductsList.loyalty?.minLoyaltyPointsReq}{" "}
                            points)
                          </span>
                        </div>
                      )}

                      <div
                        style={{
                          color: "rgb(81, 148, 198)",
                          fontWeight: "600",
                        }}
                      >
                        {returnProductsList.roundOff}
                      </div>
                      {!!overallDiscount.amount && (
                        <div
                          style={
                            !overallDiscount.show
                              ? {
                                  textDecoration: "line-through",
                                  color: "green",
                                  fontWeight: "600",
                                }
                              : {
                                  color: "green",
                                  fontWeight: "600",
                                }
                          }
                        >
                          <div
                            style={
                              overallDiscount.returned
                                ? {
                                    display: "none",
                                  }
                                : {}
                            }
                          >
                            {parseFloat(overallDiscount.amount).toFixed("2")}
                          </div>
                        </div>
                      )}
                      {returnItemModal &&
                        otherCharger?.map((i) => {
                          return parseFloat(i.price) ? (
                            <div
                              style={
                                i.returned
                                  ? {
                                      textDecoration: "line-through",
                                      fontWeight: "600",
                                    }
                                  : {
                                      fontWeight: "600",
                                    }
                              }
                            >
                              <span
                                style={
                                  i.returned
                                    ? {
                                        display: "none",
                                      }
                                    : {}
                                }
                              >
                                {parseFloat(i.price).toFixed(2)}
                              </span>
                            </div>
                          ) : null;
                        })}
                      <div
                        style={{
                          color: "red",
                          fontWeight: "600",
                        }}
                      >
                        {parseFloat(repaidAmount).toFixed("2")}
                      </div>
                    </div>
                  </div>
                  {/* <div className="repayAmountContainer">
                    <div className="repayAmount">Repay Amount</div>
                    <div style={{ color: "#208441" }}>
                       {parseFloat(amountToBeRepaid).toFixed("2")}
                    </div>
                  </div> */}
                </div>
                <Modal.Footer>
                  {!billFullyReturned && (
                    <button
                      className="addAddrButton"
                      style={{
                        border: "0",
                        backgroundColor: "#ef4667",
                        color: "#fff",
                        fontSize: "15px",
                        fontWeight: "600",
                        borderRadius: "6px",
                        padding: "10px 14px",
                      }}
                      onClick={() => {
                        cancelBill();
                      }}
                      disabled={cancelLoading}
                    >
                      Confirm
                      {cancelLoading && (
                        <Spinner
                          variant="primary"
                          animation="border"
                          size="sm"
                          style={{
                            marginLeft: "10px",
                            backgroundColor: "#fff",
                          }}
                        />
                      )}
                    </button>
                  )}
                </Modal.Footer>
              </div>
            ) : (
              <div>loading...</div>
            )}
          </Modal>
        </div>
      ) : (
        <div
          style={{
            position: "fixed",
            left: "50%",
            top: "50%",
            transform: "translate(50%, -50%)",
            zIndex: 100,
          }}
        >
          <Loader size={70} />
        </div>
        // <div style={{ backgroundColor: "white" }}>
        //   <div style={{ margin: "20px" }}>
        //     <Skeleton
        //       style={{
        //         backgroundColor: "white",
        //         border: "0.4px solid rgb(221, 221, 221)",
        //       }}
        //       width={300}
        //       height={60}
        //       animation="wave"
        //     />
        //   </div>
        //   <div className="overview-container">
        //     <div style={{ width: "100%", height: "100%" }}>
        //       <div className="analytics-main" style={{ marginTop: "-40px" }}>
        //         <Skeleton
        //           className="card-style"
        //           width={250}
        //           height={200}
        //           animation="wave"
        //         />
        //         <Skeleton
        //           className="card-style"
        //           width={250}
        //           height={200}
        //           animation="wave"
        //         />
        //         <Skeleton
        //           className="card-style"
        //           width={250}
        //           height={200}
        //           animation="wave"
        //         />
        //         <Skeleton
        //           className="card-style"
        //           width={250}
        //           height={200}
        //           animation="wave"
        //         />
        //       </div>
        //       <div
        //         className="goto-billing-button"
        //         style={{ marginTop: "-20px", marginBottom: "-300px" }}
        //       >
        //         <Skeleton
        //           style={{
        //             backgroundColor: "white",
        //             border: "0.4px solid rgb(221, 221, 221)",
        //           }}
        //           width={150}
        //           height={80}
        //           animation="wave"
        //         />
        //       </div>
        //       <div style={{ marginTop: "-50px" }}>
        //         <Skeleton
        //           style={{
        //             backgroundColor: "white",
        //             border: "0.4px solid rgb(221, 221, 221)",
        //             marginTop: "-50px",
        //           }}
        //           height={400}
        //           width={"100%"}
        //           animation="wave"
        //         />
        //       </div>
        //     </div>
        //   </div>
        // </div>
      )}
    </>
  );
};
export default withRouter(OverView);

const EditJsx = ({ setEditable = () => {}, tempCount, fullyReturned }) => {
  return (
    <button
      style={{
        backgroundColor: "transparent",
        border: "0",
        padding: 0,
        height: 20,
      }}
      onClick={() => {
        setEditable({
          show: true,
          count: parseFloat(tempCount),
        });
      }}
      disabled={fullyReturned}
    >
      <AiFillEdit />
    </button>
  );
};
const EditableQuantity = ({
  data,
  setReturnProductsList = () => {},
  setReturnProductsItem = () => {},
}) => {
  const [editable, setEditable] = useState({
    show: false,
    count: 0,
  });

  useEffect(() => {
    setReturnProductsList((prev) => {
      return {
        ...prev,
        items: prev.items.map((i) => {
          if (i.productId === data.productId) {
            return {
              ...i,
              editEnabled: editable.show,
            };
          }
          return i;
        }),
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editable.show, data.productId]);

  return (
    <div key={data.productId}>
      {!editable.show && (
        <div>
          {parseFloat(data.tempCount).toFixed(2)}
          {"  "}
          {data.fullyReturned ? (
            <Tooltip title="Already Returned">
              <EditJsx
                setEditable={setEditable}
                tempCount={data.tempCount}
                fullyReturned={data.fullyReturned}
                tempReturnedCount={data.tempReturnedCount}
              />{" "}
            </Tooltip>
          ) : (
            <EditJsx
              setEditable={setEditable}
              fullyReturned={data.fullyReturned}
              tempCount={data.tempCount}
              tempReturnedCount={data.tempReturnedCount}
            />
          )}
        </div>
      )}

      {editable.show && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <span
            style={{
              display: "inline-flex",
              border: "1px solid #ccc",
            }}
          >
            <Button
              style={{
                backgroundColor: "transparent",
                border: "0",
                padding: 0,
                height: 20,
              }}
              disabled={editable.count <= 1}
              onClick={() => {
                setEditable((prev) => ({
                  ...prev,
                  count: prev.count - 1,
                }));
              }}
            >
              <BiMinus
                size={20}
                style={{
                  cursor: "pointer",
                }}
              />
            </Button>

            <span
              style={{
                borderRight: "1px solid #ccc",
                borderLeft: "1px solid #ccc",
                padding: "0 6px",
                userSelect: "none",
              }}
            >
              {parseFloat(editable.count).toFixed(2)}
            </span>
            <Button
              style={{
                backgroundColor: "transparent",
                border: "0",
                padding: 0,
                height: 20,
              }}
              disabled={
                editable.count ===
                parseFloat(data.count || 0) -
                  parseFloat(data.tempReturnedCount || 0)
              }
              onClick={() => {
                setEditable((prev) => ({
                  ...prev,
                  count: prev.count + 1,
                }));
              }}
            >
              <BiPlus size={20} />
            </Button>
          </span>
          <span>
            <button
              style={{
                backgroundColor: "transparent",
                border: "0",
                padding: 0,
              }}
              onClick={() => {
                setEditable({
                  show: false,
                  count: 0,
                });
              }}
            >
              <IoIosCloseCircleOutline
                role="button"
                style={{
                  cursor: "pointer",
                }}
                size={20}
              />
            </button>
            <button
              style={{
                backgroundColor: "transparent",
                border: "0",
                padding: 0,
              }}
              onClick={() => {
                const productTemp = {
                  ...data,
                  tempCount: editable.count,
                };
                setReturnProductsList((prev) => {
                  return {
                    ...prev,
                    items: prev.items.map((i) => {
                      if (i.productId === data.productId) {
                        return {
                          ...productTemp,
                          tableData: {
                            ...i.tableData,
                            checked: true,
                          },
                        };
                      }
                      return i;
                    }),
                  };
                });
                setEditable({
                  show: false,
                  count: 0,
                });
                setReturnProductsItem((prev) => {
                  const isExist = prev.find(
                    (i) => i.productId === productTemp.productId
                  );

                  if (isExist) {
                    // if (
                    //   parseFloat(productTemp.count) ===
                    //   parseFloat(productTemp.tempCount || 0) +
                    //     parseFloat(productTemp.tempReturnedCount || 0)
                    // ) {
                    //   return prev.filter(
                    //     (i) => i.productId !== productTemp.productId
                    //   );
                    // }
                    return prev.map((i) => {
                      if (i.productId === productTemp.productId) {
                        return {
                          ...productTemp,
                          tableData: {
                            ...i.tableData,
                            checked: true,
                          },
                          returned:
                            parseFloat(editable.count) +
                            parseFloat(data.tempReturnedCount || 0),
                        };
                      }
                      return i;
                    });
                  }

                  return [
                    ...prev,
                    {
                      ...productTemp,
                      returned:
                        parseFloat(editable.count) +
                        parseFloat(data.tempReturnedCount || 0),
                      tableData: { checked: true },
                    },
                  ];
                });
              }}
            >
              <IoIosCheckmarkCircleOutline
                style={{
                  cursor: "pointer",
                }}
                size={20}
              />
            </button>
          </span>
        </div>
      )}
    </div>
  );
};
